import { useState } from 'react';
import { Link } from 'react-router-dom';
import { requestPasswordReset } from '../features/iso27001/security/securityApi';
import { Button } from '../components/ui/button';
import { Input } from '../components/ui/input';
import { Footer } from '../components/Footer';

export function ForgotPasswordPage() {
  const [email, setEmail] = useState('');
  const [message, setMessage] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setLoading(true);
    setError('');
    setMessage('');
    try {
      const result = await requestPasswordReset(email.trim());
      setMessage(result.message);
    } catch {
      setError('No se pudo procesar la solicitud. Intente más tarde.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className='min-h-screen flex flex-col bg-background'>
      <div className='flex flex-1 flex-col justify-center px-6 py-12 lg:px-8'>
        <div className='sm:mx-auto sm:w-full sm:max-w-sm'>
          <h2 className='text-center text-2xl font-bold text-foreground'>Recuperar contraseña</h2>
        </div>
        <div className='mt-10 sm:mx-auto sm:w-full sm:max-w-sm bg-card px-6 py-8 shadow-sm rounded-lg border'>
          <form onSubmit={(e) => void handleSubmit(e)} className='space-y-4'>
            <Input
              type='email'
              placeholder='Email'
              autoComplete='username'
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
            />
            {message && <p className='text-sm text-green-600'>{message}</p>}
            {error && <p className='text-sm text-red-500'>{error}</p>}
            <Button type='submit' className='w-full' disabled={loading}>
              {loading ? 'Enviando...' : 'Enviar enlace'}
            </Button>
            <p className='text-center text-sm'>
              <Link to='/login' className='text-primary hover:underline'>
                Volver al inicio de sesión
              </Link>
            </p>
          </form>
        </div>
      </div>
      <Footer />
    </div>
  );
}
